export const FETCHING_MARKETING_REPORTS = 'FETCHING_MARKETING_REPORTS';
export const FETCH_MARKETING_REPORTS_SUCCESS = 'FETCH_MARKETING_REPORTS_SUCCESS';
export const FETCH_MARKETING_REPORTS_ERROR = 'FETCH_MARKETING_REPORTS_ERROR';
